import wangEditor from "wangeditor";

const editor = {
    state: {
        editor: ""
    },
    actions: {
        getEditor(store, dom) {
            store.state.editor = new wangEditor(dom);
            store.state.editor.customConfig.menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'strikeThrough',  // 删除线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'link',  // 插入链接
                'list',  // 列表
                'justify',  // 对齐方式
                'quote',  // 引用
                'emoticon',  // 表情
                'image',  // 插入图片
                'table',  // 表格
                'video',  // 插入视频
                'code',  // 插入代码
                'undo',  // 撤销
                'redo'  // 重复
            ];

            // 下面两个配置，使用其中一个即可显示“上传图片”的tab。但是两者不要同时使用！！！
            store.state.editor.customConfig.uploadImgShowBase64 = true   // 使用 base64 保存图片
            // editor.customConfig.uploadImgServer = '/upload'  // 上传图片到服务器

            // 将图片大小限制为 3M
            store.state.editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;

            // 限制一次最多上传 5 张图片
            store.state.editor.customConfig.uploadImgMaxLength = 5;

            // 隐藏网络图片tab
            store.state.editor.customConfig.showLinkImg = false;

            // 创建文本：editor.create();
            // 获取文本：var content = editor.txt.html(); || var content = editor.txt.text();
            // 设置文本：editor.txt.html(content); || editor.txt.text(content);
        }
    }
};

export default editor;


// WEBPACK FOOTER //
// ./src/store/modules/editor.js